(function() {

    $('form.mailing-list').on('submit', function(e) {
        var $form = $(this),
            $alert = $form.find('.alert'),
            formData = $form.serialize();

        e.preventDefault();

        // handle submission
        $.post('/api/mailchimp/', formData, function(response) {
            POP.Message.response($alert, response);

            if (response && response.code == 200) {
                $form.find(':input').attr('disabled', 'disabled');
                $form.unbind('submit');
            }
        });
    });

})();
